<style lang="scss">
//滚动条的滑块
.monitorEfficiency::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}
</style>

<template>
  <div ref="container" class="monitorEfficiency" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
    <div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 10px;justify-content: space-between;">
      <div style="display: flex;align-items: center;">
        <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
        <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
          {{ $t("shengchanshujufenxi") }}
        </p>
      </div>
    </div>
    <div style="display: flex;justify-content: space-between;padding: 10px 0;" :style="{ height: chartHeight + 'px' }">
      <div id="monitorProduceChart" style="flex:1" :style="{ height: chartHeight - 20 + 'px' }"></div>
      <div id="monitorKjlChart" style="flex:1;" :style="{ height: chartHeight - 20 + 'px' }"></div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_monitor_cockpit_produce_data",
  components: {},
  props: {
    cockpitData: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      timer: null,
      chart1: null,
      option1: null,
      chart2: null,
      option2: null,
      chartHeight: 0,
      produce: {},
    };
  },
  created() {},

  watch: {
    cockpitData(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.makeChart();
    },
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
    this.makeChart();
    this.resize();
  },

  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    makeChart() {
      this.produce.months = this.cockpitData.monthSummaryDate.badQuantityByMonth.map((item) => {
        return item.reportDate;
      });
      this.produce.months = this.produce.months.filter((item) => {
        return item != null;
      });
      this.produce.goods = this.cockpitData.monthSummaryDate.badQuantitySumByMonth.map((item) => {
        return item.badQuantitySum;
      });
      this.produce.goods = this.produce.goods.filter((item) => {
        return item != null;
      });
      this.produce.bads = this.cockpitData.monthSummaryDate.badQuantityByMonth.map((item) => {
        return item.badQuantitySum;
      });
      this.produce.bads = this.produce.bads.filter((item) => {
        return item != null;
      });

      this.produce.months2 = this.cockpitData.monthSummaryDate.startupRateTopByMonth.map((item) => {
        return item.summaryDate;
      });
      this.produce.months2 = this.produce.months2.filter((item) => {
        return item != null;
      });

      this.produce.eqs = this.cockpitData.monthSummaryDate.startupRateTopByMonth.map((item) => {
        return item.equipmentName;
      });
      this.produce.eqs = this.produce.eqs.filter((item) => {
        return item != null;
      });
      this.produce.ups = this.cockpitData.monthSummaryDate.startupRateTopByMonth.map((item) => {
        return item.startupRate;
      });
      this.produce.ups = this.produce.ups.filter((item) => {
        return item != null;
      });

      console.log(this.produce);

      this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
      if (!this.chart1) {
        setTimeout(() => {
          this.initChart1();
        }, 100);
      }
      setTimeout(() => {
        this.option1.xAxis.data = this.produce.months;
        this.option1.series[0].data = this.produce.goods;
        this.option1.series[1].data = this.produce.bads;
        this.chart1.setOption(this.option1);
      }, 200);

      if (!this.chart2) {
        setTimeout(() => {
          this.initChart2();
        }, 100);
      }

      setTimeout(() => {
        this.option2.xAxis.data = this.produce.months2;
        this.option2.series[0].data = this.produce.ups;
        this.chart2.setOption(this.option2);
      }, 200);
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
        if (!this.chart1) {
          return;
        }

        this.chart1.getDom().style.height = this.chartHeight - 20 + "px";
        this.chart1.resize();
        if (!this.chart2) {
          return;
        }

        this.chart2.getDom().style.height = this.chartHeight - 20 + "px";
        this.chart2.resize();
      }, 800);
    },
    initChart1() {
      this.option1 = {
        backgroundColor: null,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            label: {
              formatter: "{value} ",
            },
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: "rgba(0,0,0,0.8)",
          borderWidth: 0,
          textStyle: {
            color: "#C0C4CC",
          },
          valueFormatter: (value) => {
            return value.toFixed(0);
          },
        },
        grid: {
          left: "0",
          right: "10",
          bottom: "0",
          top: "50",
          containLabel: true,
        },
        legend: {
          left: "center",
          top: "0%",
          textStyle: {
            color: "#FFFFFF",
            fontSize: 12,
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25,
        },
        dataZoom: [
          {
            show: false,
            height: 8,
            xAxisIndex: [0],
            bottom: 0,
            start: 0,
            end: 100,
            handleIcon: "path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z",
            handleSize: "100%",
            handleStyle: {
              color: "rgba(255, 255, 255,1",
            },
            textStyle: {
              color: "transparent",
              fontSize: 12,
            },
            fillerColor: "#CBCED4",
            borderColor: "transparent",
            backgroundColor: "transparent",
            showDataShadow: false,
            brushSelect: false,
          },
          {
            type: "inside",
            disabled: false,
          },
        ],
        xAxis: {
          show: true,
          type: "category",
          name: "",
          nameLocation: "end",
          nameTextStyle: {
            fontSize: 12,
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
              color: "#000",
              width: 1,
            },
          },
          axisTick: {
            show: false,
            alignWithLabel: false,
            interval: "auto",
            inside: false,
            length: 5,
            lineStyle: {
              type: "solid",
              width: 1,
              color: "#909399",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              width: 1,
              color: "#909399",
            },
          },
          axisLabel: {
            margin: 8,
            interval: "auto",
            rotate: 0,
            fontSize: 12,
            color: "#C0C4CC",
            formatter: (month) => {
              return month.substring(4, 6) + this.$t("yue");
            },
          },
          data: this.produce.months,
        },
        yAxis: [
          {
            show: true,
            type: "value",
            name: "",
            min: 0,
            nameTextStyle: {
              color: "#909399",
            },

            axisLine: {
              show: false,
              lineStyle: {
                color: "#909399",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: "{value} ",
              rotate: 0,
              textStyle: {
                color: "#C0C4CC",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#606672",
              },
            },
          },
        ],
        series: [
          {
            name: this.$t("chanliangzuigao"),
            type: "bar",
            barWidth: "12px",
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#6FE5FF",
                  },
                  {
                    offset: 1,
                    color: "#1C70C6",
                  },
                ]),
                barBorderRadius: 6,
              },
            },
            label: {
              show: false,
              rotate: 0,
              color: "#419FFF",
              position: "top",
              fontSize: 12,
            },
            data: this.produce.goods,
          },
          {
            name: this.$t("buliangzuigao"),
            type: "bar",
            barWidth: "12px",
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#FD9DFF",
                  },
                  {
                    offset: 1,
                    color: "#4F32FF",
                  },
                ]),
                barBorderRadius: 6,
              },
            },
            label: {
              show: false,
              rotate: 0,
              color: "#5C41FF",
              position: "top",
              fontSize: 12,
              labelFormatter: "{data} %",
            },
            data: this.produce.bads,
          },
        ],
      };

      var chartDom = document.getElementById("monitorProduceChart");
      this.chart1 = this.echarts.init(chartDom);
      this.option1 && this.chart1.setOption(this.option1);
    },
    initChart2() {
      this.option2 = {
        grid: {
          left: "10",
          right: "0",
          bottom: "0",
          top: "50",
          containLabel: true,
        },
        legend: {
          left: "center",
          top: "0%",
          textStyle: {
            color: "#FFFFFF",
            fontSize: 12,
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
          backgroundColor: "rgba(0,0,0,0.8)",
          borderWidth: 0,
          textStyle: {
            color: "#C0C4CC",
          },
        },
        xAxis: {
          type: "category",
          data: [],
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
              color: "#000",
              width: 1,
            },
          },
          axisTick: {
            show: false,
            alignWithLabel: false,
            interval: "auto",
            inside: false,
            length: 5,
            lineStyle: {
              type: "solid",
              width: 1,
              color: "#909399",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              width: 1,
              color: "#909399",
            },
          },
          axisLabel: {
            margin: 8,
            interval: "auto",
            rotate: 0,
            fontSize: 12,
            color: "#C0C4CC",
            formatter: (month) => {
              return month.substring(4, 6) + this.$t("yue");
            },
          },
        },
        yAxis: [
          {
            show: true,
            type: "value",
            name: "",
            min: 0,
            nameTextStyle: {
              color: "#909399",
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#909399",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: "{value} %",
              rotate: 0,
              textStyle: {
                color: "#C0C4CC",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#606672",
              },
            },
          },
        ],
        series: [
          {
            name: this.$t("kaijilvzuigao"),
            data: [],
            type: "line",
            label: {
              normal: {
                show: true,
                position: "top",
                formatter: (params) => {
                  return this.produce.eqs[params.dataIndex];
                },
                color: "#FFFFFF",
              },
            },
            //symbol: 'none',
            itemStyle: {
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#4DD868",
                },
                {
                  offset: 1,
                  color: "#4DD868",
                },
              ]),
              barBorderRadius: 6,
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(93, 221, 117, 0)", // 0% 处的颜色
                  },
                  {
                    offset: 0.01,
                    color: "rgba(115, 251, 140, 0.5)", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(93, 221, 117, 0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };

      var chartDom = document.getElementById("monitorKjlChart");
      this.chart2 = this.echarts.init(chartDom);
      this.option2 && this.chart2.setOption(this.option2);
    },
  },
};
</script>
